import React from 'react';
import Navbar from '../components/Navbar';
import { Footer } from '../App';
import AgreementCreator from '../components/AgreementCreator';

function AgreementsPage() {
  return (
    <>
      <div className="fixed inset-0 -z-10 grid-pattern opacity-30"></div>
      <div className="fixed top-0 left-0 right-0 h-screen w-screen -z-10 bg-gradient-radial from-primary-900/20 via-transparent to-transparent opacity-30"></div>
      <Navbar />
      <main className="app-main min-h-screen transition-colors duration-300 bg-white dark:bg-gradient-to-br dark:from-dark-900 dark:to-dark-950 text-gray-900 dark:text-white" style={{background: 'var(--background)', color: 'var(--text)'}}>
        <div className="container mx-auto px-4 py-8 pt-24">
          <h1 className="text-4xl font-bold text-center mb-6 bg-gradient-to-r from-primary-600 to-accent bg-clip-text text-transparent">
            Digital Buyer-Seller Agreements
          </h1>
          <p className="text-center mb-8 text-lg max-w-3xl mx-auto text-gray-600 dark:text-gray-400">
            Create blockchain-secured agreements on Polygon Mainnet
          </p>

          <div className="card max-w-6xl mx-auto">
            <AgreementCreator />
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default AgreementsPage;
